import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { DragHandleButton } from './styled.js';
/**
 * The grab handle for a draggable row. Stops click and pointer-down from bubbling to the row, so grabbing or
 * tapping the handle never triggers the row's own behaviour (expand/collapse, onClick). @dnd-kit binds its
 * pointer sensor with a native listener on this element, which fires before React's bubbling — so stopping
 * propagation here doesn't interfere with starting a drag.
 */
export const DragHandle = forwardRef(function DragHandle({ onClick, onPointerDown, ...props }, ref) {
    return (_jsx(DragHandleButton, { ref: ref, onClick: (event) => {
            event.stopPropagation();
            onClick?.(event);
        }, onPointerDown: (event) => {
            event.stopPropagation();
            onPointerDown?.(event);
        }, ...props }));
});
